export default __webpack_public_path__ + "static/media/search-16px.1be37e47.svg";